import styled from 'styled-components';
import { ellipsis } from 'polished';

const StyledUserProfile = styled.section`
    padding: 30px 10px 10px;
    margin: 0 20px 10px;
    border-bottom: solid 1px #e8e8e8;

    .gx-avatar-name {
        ${ellipsis('200px')}
        vertical-align: middle;
    }

    footer {
        transform: scale(0.8);
    }
`;

export default StyledUserProfile;
